// src/pages/components/ProjectDetailsNotes.js
import { Paper, Stack, Typography, Button, Box, TextField, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import axios from 'axios';

const MAX = 2000;

const ProjectDetailsNotesCard = ({ project, projectId, onProjectUpdated }) => {
  const [draft, setDraft] = useState(project?.notes || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setDraft(project?.notes || '');
  }, [project?.notes]);

  const saveNotes = async () => {
    const next = (draft || '').trim();
    if (saving) return;

    setSaving(true);
    setError('');

    try {
      const res = await axios.patch(`/api/v1/project/${projectId}/details`, { notes: next });

      const doc = res?.data?.data?.project || res?.data?.data || res?.data || null;

      if (doc && onProjectUpdated) {
        onProjectUpdated(doc);
      }
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to save notes.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Paper variant="outlined" sx={{ p: 2, position: 'relative', mb: 5 }}>
      <Typography
        color="text.secondary"
        variant="caption"
        sx={{
          position: 'absolute',
          top: -8,
          left: 12,
          backgroundColor: 'background.paper',
          px: 0.5,
          fontWeight: 700,
        }}
      >
        Project Notes
      </Typography>

      <Stack spacing={1.5}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <TextField
            value={draft}
            onChange={(e) => {
              const v = e.target.value;
              setDraft(v.length > MAX ? v.slice(0, MAX) : v);
            }}
            placeholder="Write project notes…"
            fullWidth
            multiline
            minRows={5}
            maxRows={12}
            variant="standard"
            InputProps={{
              disableUnderline: true,
              sx: {
                fontSize: 14,
                lineHeight: 1.6,
              },
            }}
            helperText={error ? error : `${draft.length}/${MAX}`}
            FormHelperTextProps={{
              sx: {
                textAlign: 'right',
                mt: 0.5,
                color: error ? 'error.main' : 'text.secondary',
              },
            }}
          />

          <Button
            variant="outlined"
            size="small"
            onClick={saveNotes}
            disabled={saving || draft === (project?.notes || '')}
            sx={{ alignSelf: 'flex-end', mt: 1 }}
            startIcon={saving ? <CircularProgress size={14} /> : null}
          >
            Save Notes
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};

export default ProjectDetailsNotesCard;
